const clean = (value) => String(value || "").trim();

const comparable = (address) => [
  address.street_1,
  address.street_2,
  address.city,
  address.state,
  address.zip_code,
].map((value) => clean(value).toUpperCase()).join("|");

export const groupedAddress = (values, fieldIds) => ({
  street_1: clean(values?.[fieldIds.street]),
  street_2: clean(values?.[fieldIds.secondary]),
  city: clean(values?.[fieldIds.city]),
  state: clean(values?.[fieldIds.state]).toUpperCase(),
  zip_code: clean(values?.[fieldIds.zip]),
  country: clean(values?.[fieldIds.country]) || "United States",
});

export const buildSmartyAddressSuggestion = ({ values, fieldIds, match }) => {
  const components = match?.components || {};
  const entered = groupedAddress(values, fieldIds);
  const suggested = {
    street_1: clean(match?.deliveryLine1 || match?.delivery_line_1),
    street_2: clean(match?.deliveryLine2 || match?.delivery_line_2),
    city: clean(components.cityName || components.city_name),
    state: clean(
      components.state
      || components.stateAbbreviation
      || components.state_abbreviation,
    ).toUpperCase(),
    zip_code: clean(components.zipCode || components.zipcode),
    country: "United States",
  };
  if (
    !suggested.street_1
    || !suggested.city
    || !suggested.state
    || !suggested.zip_code
    || comparable(entered) === comparable(suggested)
  ) {
    return null;
  }

  const suggestedValues = { ...(values || {}) };
  if (fieldIds.street) suggestedValues[fieldIds.street] = suggested.street_1;
  if (fieldIds.secondary) suggestedValues[fieldIds.secondary] = suggested.street_2;
  if (fieldIds.city) suggestedValues[fieldIds.city] = suggested.city;
  if (fieldIds.state) suggestedValues[fieldIds.state] = suggested.state;
  if (fieldIds.zip) suggestedValues[fieldIds.zip] = suggested.zip_code;
  if (fieldIds.country) suggestedValues[fieldIds.country] = suggested.country;
  Object.assign(suggestedValues, suggested, { country: "US" });

  return {
    entered,
    suggested,
    values: suggestedValues,
    fingerprint: JSON.stringify([entered, suggested]),
  };
};

export const addressLines = (address) => [
  address?.street_1,
  address?.street_2,
  [
    address?.city,
    [address?.state, address?.zip_code].filter(Boolean).join(" "),
  ].filter(Boolean).join(", "),
].filter(Boolean);
